import { delay } from 'rxjs/operator/delay';
import { Observable } from 'rxjs/Observable';
import { DizionarioModel } from '../../models/shared/dizionario.model';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MdDialog, MdDialogRef, MdSnackBar, MD_DIALOG_DATA, MdDatepickerModule } from "@angular/material";
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { IncassoAssegniListItemModel } from '../../models/incassi/incasso-assegni-list-item.model';
import { IncassoModel } from "../../models/incassi/incasso.model";
import { IncassoContantiListItemModel } from '../../models/incassi/incasso-contanti-list-item.model';
import { IncassiService } from '../../services/incassi.service';
import { IncassiDettaglioService } from '../../services/incassi-dettaglio.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DistinteVersamentiService } from '../../services/distinte-versamenti.service';
import { DatePickerDirective } from '../../directives/datepicker.directive';
import { DateAdapter } from '@angular/material';
export class DistintaAssegniDialogConfigModel {

// riferimento, da lasciare invariato! è competenza del chiamante
constructor(public incassoRef: IncassoModel,
    public showAssegnoCircolare: boolean, public reload: boolean = false, public incassoResult: IncassoModel = null
  ) { }
}

@Component({
  selector: 'app-distinta-assegni',
  templateUrl: './distinta-assegni.component.html',
  styleUrls: ['./distinta-assegni.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DistintaAssegniDialog implements OnInit {
  saving: boolean = false;
  config: DistintaAssegniDialogConfigModel = null;
  hasAssegno:boolean=false;
  // mantiene una copia locale dei dati dell'incasso passati come parametro dal chiamante
  incassoCorrente: IncassoModel = null;
  assegnoCorrente: IncassoAssegniListItemModel = null;
  TIPI_ASSEGNO: DizionarioModel[] = null;
  imgFronte: FormData;
  imgRetro: FormData;
  imageToShowF: any;
  imageToShowR: any;
  isImageLoading: boolean;
  isBancaLoading:boolean;
  constructor(
    public dialogRef: MdDialogRef<DistintaAssegniDialog>,
    @Inject(MD_DIALOG_DATA) public data: DistintaAssegniDialogConfigModel,
    private incassiService: IncassiService,
    private distintaService: DistinteVersamentiService,
    private incassiDettaglioService: IncassiDettaglioService,
    private sanitizer: DomSanitizer,
    private snackBar: MdSnackBar,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('it-IT');
    this.config = data;
  }

  ngOnInit() {
    this.incassiService.getTipiAssegno()
      .subscribe(r => this.TIPI_ASSEGNO = r);
    this.incassoDeepCopy(this.config.incassoRef);
    if(this.incassoCorrente.assegni!=null&&this.incassoCorrente.assegni.length>0) {
      this.hasAssegno=true;
    }
    this.buildForm();
  }

  // effettua una copia dell'incasso
  private incassoDeepCopy(m: IncassoModel) {
    this.incassoCorrente = {
      tokenIncasso: m.tokenIncasso,
      tokenCliente: m.tokenCliente,
      dataIncasso: m.dataIncasso,
      totaleValuta: m.totaleValuta,
      totaleAssegni: m.totaleAssegni,
      totaleIncasso: m.totaleIncasso,
      statoIncasso: m.statoIncasso,
      id: m.id,
      zona: m.zona,
      clienteRagioneSociale: m.clienteRagioneSociale
    };

    if (m.contanti) {
      this.incassoCorrente.contanti = m.contanti.map(
        (cont: IncassoContantiListItemModel) => Object.assign({}, cont)
      );
    }

    if (m.assegni) {
      // NB: dalla lista degli assegni vanno esclusi quelli circolari che sostituiscono i contanti,
      // che andrebbero visualizzati nella distinta contanti (??)
      this.incassoCorrente.assegni = m.assegni.map(
        (assegno: IncassoAssegniListItemModel) => Object.assign({}, assegno)
      );
    }

  }

  //costruisce la form sulla base di this.incassoCorrente
  private buildForm(): void {
    if (!this.incassoCorrente.assegni) {
      this.incassoCorrente.assegni = [];
    }
    this.focusDate();
    
  }

  fileChange(event, id) {
    if (this.assegnoCorrente) {
      if (id === 1) {
        this.imgFronte = event.target.files;
      }
      if (id === 2) {
        this.imgRetro = event.target.files;
      }
    }
  }
  formatDate(inputDate): string {
    let splittedDate = inputDate.split("-");
    let resultDate = splittedDate[2] + "/" + splittedDate[1] + "/" + splittedDate[0];
    return resultDate;
  }
  salvaAssegno() {
    this.saving = true;
    let savingF=false;
    let savingR=false;
    let regexNumeri = /^\d+$/;
    //VERIFICA DATA ASSEGNO: <oggi non inferiore a due anni
    let dNow: Date = new Date();
    let dNowY = new Date().getFullYear();
    let newDateY:number;
    if(this.assegnoCorrente.dataAssegno!=null) {
      newDateY = this.assegnoCorrente.dataAssegno.getFullYear();
    } else {
      this.saving=false;
      this.showError("Specificare la data assegno");
      return false;
    }
    let diffY =  dNowY- newDateY ;
    let dateFieldValue=this.assegnoCorrente.dataAssegno;
    let year = dateFieldValue.getFullYear();
    let month = dateFieldValue.getMonth();
    let day = dateFieldValue.getDate();
    let dateOnly = new Date(year,month,day);
    
    if (dNow < dateOnly || diffY > 2) {
      this.saving = false;
      this.showError("La data assegno deve rispettari i vincoli di validità");
      return false;
    }
    if (!regexNumeri.test(this.assegnoCorrente.abi)) {
      this.saving = false;
      this.showError("Il campo ABI è obbligatorio e può essere formato solo da numeri");
      return false;
    }
    if (!regexNumeri.test(this.assegnoCorrente.cab)) {
      this.saving = false;
      this.showError("Il campo CAB è obbligatorio e può essere formato solo da numeri");
      return false;
    }
    if(this.assegnoCorrente.nomeBanca === "") {
      this.saving = false;
      this.showError("Inserire un ABI e CAB corrispondente ad una banca.");
      return false;
    }

    if (!regexNumeri.test(this.assegnoCorrente.numeroAssegno)) {
      this.saving = false;
      this.showError("Il campo numero assegno è obbligatorio e può essere formato solo da numeri");
      return false;
    }
  
    let rex=/^(\d+(\.\d{1,2}){0,1})$/;
    if (!rex.test(this.assegnoCorrente.importo+'')) {
      this.saving = false;
      // tslint:disable-next-line:max-line-length
      this.showError('Il campo importo deve rappresentare un numero decimale valido per la valuta, il separatore da intero a decimale deve essere "."');
      return false;
    }
    //this.assegnoCorrente.dataAssegno = formattedDateString;
    //AGGIORNAMENTO DELLA LISTA ASSEGNI
    if (!this.incassoCorrente.assegni.find(a => a.token === this.assegnoCorrente.token)) {
      //NUOVO
      if (!this.incassoCorrente.statoIncasso || this.incassoCorrente.tokenIncasso === '' || !this.incassoCorrente.tokenIncasso) {
        this.incassiService.insert(this.incassoCorrente)
          .subscribe((i: any) => {
            this.incassoCorrente.tokenIncasso = i.incasso.tokenIncasso;


            //gestione del file
            this.incassiDettaglioService.insertAssegni(this.assegnoCorrente, this.incassoCorrente.tokenIncasso)
              .subscribe((resA: any) => {
                this.hasAssegno=true;
                this.config.reload = true;
                this.config.incassoResult = this.incassoCorrente;
                //carico le immagini
                if (resA.inserted && resA.assegnoInserito.token) {
                  this.assegnoCorrente = resA.assegnoInserito.assegno;

                  //img fronte
                  if (this.imgFronte) {
                    savingF=true;
                    let fileF: File = this.imgFronte[0];
                    let formDataF: FormData = new FormData();
                    formDataF.append('file', fileF, fileF.name);
                    formDataF.append('TokenProprietario', this.assegnoCorrente.token);
                    formDataF.append('idAllegatoTipo', '5');
                    formDataF.append('FronteRetro', 'F');
                    this.incassiDettaglioService.uploadImmagineAssegno(formDataF).subscribe(
                      (data: any) => {
                        savingF=false;
                        this.saving=false&&(!savingF&&!savingR);
                        if (data.result.result === false) {
                          //this.showError(data.result.message);
                          // return false;
                        } else {

                        }
                      },
                      error => {
                        //this.showError("Errore durante la procedura di upload delle immagini");
                        //return false;
                        savingF=false;
                        this.saving=false&&(!savingF&&!savingR);
                      }
                    );
                  }
                  //img retro
                  if (this.imgRetro) {
                    savingR=true;
                    let fileR: File = this.imgRetro[0];
                    let formDataR: FormData = new FormData();
                    formDataR.append('file', fileR, fileR.name);
                    formDataR.append('TokenProprietario', this.assegnoCorrente.token);
                    formDataR.append('idAllegatoTipo', '5');
                    formDataR.append('FronteRetro', 'R');
                    this.incassiDettaglioService.uploadImmagineAssegno(formDataR).subscribe(
                      (data: any) => {
                        savingR=false;
                        this.saving=false&&(!savingF&&!savingR);
                        if (data.result.result === false) {
                          //this.showError(data.result.message);
                          //return false;
                        } else {

                        }
                      },
                      error => {
                        savingR=false;
                        this.saving=false&&(!savingF&&!savingR);
                        //this.showError("Errore durante la procedura di upload delle immagini");
                        //return false;
                      }
                    );
                  }

                  //Aggiorna gli assegni dell'incasso corrente
                  this.incassiDettaglioService.getAssegni(this.incassoCorrente.tokenIncasso)
                    .subscribe(
                      resAssegni => {
                        //Aggiorno gli stati
                        this.incassoCorrente.assegni = resAssegni;
                        if (this.incassoCorrente.statoIncasso.id === 1) {
                          //aggiorno lo stato
                          this.incassoCorrente.statoIncasso.id = 2;
                          this.incassiService.update(this.incassoCorrente).subscribe((data: any) => {

                          });

                        }
                        this.dialogRef.close(this.incassoCorrente);
                      }, error => {
                      });

                } else {
                  this.showError(resA.message);
                  this.saving = false;
                  this.dialogRef.close();
                  savingF=false;
                  return false;
                }
                //this.saving = false;
                this.saving=false&&(!savingF&&!savingR);
              },
                error => {
                  //this.saving = false;
                  savingR=false;
                  this.saving=false&&(!savingF&&!savingR);
                }
              );


          });

      } else {
        //gestione del file
        this.incassiDettaglioService.insertAssegni(this.assegnoCorrente, this.incassoCorrente.tokenIncasso)
          .subscribe((resA: any) => {

            //carico le immagini
            if (resA.inserted && resA.assegnoInserito.token) {
              this.assegnoCorrente = resA.assegnoInserito;

              //img fronte
              if (this.imgFronte) {
                savingF=true;
                let fileF: File = this.imgFronte[0];
                let formDataF: FormData = new FormData();
                formDataF.append('file', fileF, fileF.name);
                formDataF.append('TokenProprietario', this.assegnoCorrente.token);
                formDataF.append('idAllegatoTipo', '5');
                formDataF.append('FronteRetro', 'F');
                this.incassiDettaglioService.uploadImmagineAssegno(formDataF).subscribe(
                  (data: any) => {
                      savingF=false;
                      this.saving=false&&(!savingF&&!savingR);
                    if (data && data.result) {
                      
                      if (data.result.result === false) {
                        this.showError(data.result.message);
                        return false;
                      } else {

                      }
                    }
                  },
                  error => {
                    savingF=false;
                      this.saving=false&&(!savingF&&!savingR);
                      
                    // this.showError("Errore durante la procedura di upload delle immagini");
                    // return false;
                  }
                );
              }
              //img retro
              if (this.imgRetro) {
                savingR=true;
                let fileR: File = this.imgRetro[0];
                let formDataR: FormData = new FormData();
                formDataR.append('file', fileR, fileR.name);
                formDataR.append('TokenProprietario', this.assegnoCorrente.token);
                formDataR.append('idAllegatoTipo', '5');
                formDataR.append('FronteRetro', 'R');
                this.incassiDettaglioService.uploadImmagineAssegno(formDataR).subscribe(
                  (data: any) => {
                    savingR=false;
                    this.saving=false&&(!savingF&&!savingR);
                    
                    if (data && data.result) {
                      if (data.result.result === false) {
                        this.showError(data.result.message);
                        return false;
                      } else {

                      }
                    }
                  },
                  error => {savingF=false;
                    this.saving=false&&(!savingF&&!savingR);
                    
                    //this.showError("Errore durante la procedura di upload delle immagini");
                    //return false;
                  }
                );
              }

            } else {
              this.showError(resA.message);
              this.saving=false;
              savingF=false;
              this.dialogRef.close();
              return false;
            }


            //Aggiorna gli assegni dell'incasso corrente
            this.incassiDettaglioService.getAssegni(this.incassoCorrente.tokenIncasso)
              .subscribe(
                resAssegni => {

                  //Aggiorno gli stati
                  this.incassoCorrente.assegni = resAssegni;
                  if (this.incassoCorrente.statoIncasso.id === 1) {
                    //aggiorno lo stato
                    this.incassoCorrente.statoIncasso.id = 2;
                    this.incassiService.update(this.incassoCorrente).subscribe((data: any) => {


                    });

                  }

                  this.showInfo("Salvataggio avvenuto con successo");
                  this.dialogRef.close(this.incassoCorrente);
                  //this.config.incassoRef.totaleIncasso = this.incassoCorrente.totaleValuta +
                  // this.incassoCorrente.totaleAssegni+this.assegnoCorrente.importo;
                  //this.config.incassoRef.totaleAssegni+=this.assegnoCorrente.importo;
                  if(this.assegnoCorrente) {
                    this.incassoCorrente.totaleAssegni += this.assegnoCorrente.importo;
                  }
                  
                  this.saving=false&&(!savingF&&!savingR);
                      
                }, error => {
                  this.saving=false&&(!savingF&&!savingR);
                });

          },
            error => {
              this.saving=false&&(!savingF&&!savingR);
            }
          );
      }

    } else {
      //UPDATE
      this.incassiDettaglioService.updateAssegni(this.assegnoCorrente)
        .subscribe((resA: any) => {
          if (resA.updated) {
            this.assegnoCorrente = resA.assegnoUpdate.assegno;
            this.config.reload = true;
            this.config.incassoResult = this.incassoCorrente;
            //UPLOAD IMGS
            if (this.imgFronte) {
              savingF=true;
              let fileF: File = this.imgFronte[0];
              let formDataF: FormData = new FormData();
              formDataF.append('file', fileF, fileF.name);
              formDataF.append('TokenProprietario', this.assegnoCorrente.token);
              formDataF.append('idAllegatoTipo', '5');
              formDataF.append('FronteRetro', 'F');
              this.incassiDettaglioService.uploadImmagineAssegno(formDataF).subscribe(
                (data: any) => {
                  savingF=false;
                  this.saving=false&&(!savingF&&!savingR);
                  if (data && data.result) {
                    if (data.result.result === false) {
                      this.showError(data.result.message);
                      return false;
                    } else {

                    }
                  }


                },
                error => {
                  //this.showError("Errore durante la procedura di conferma");
                  //return false;
                  savingF=false;
                  this.saving=false&&(!savingF&&!savingR);
                }
              );
            }
            //img retro
            if (this.imgRetro) {
              savingR=false;
              let fileR: File = this.imgRetro[0];
              let formDataR: FormData = new FormData();
              formDataR.append('file', fileR, fileR.name);
              formDataR.append('TokenProprietario', this.assegnoCorrente.token);
              formDataR.append('idAllegatoTipo', '5');
              formDataR.append('FronteRetro', 'R');
              this.incassiDettaglioService.uploadImmagineAssegno(formDataR).subscribe(
                (data: any) => {
                  savingR=false;
                  this.saving=false&&(!savingF&&!savingR);
                  if (data) {
                    if (data.result.result === false) {
                      this.showError(data.result.message);
                      return false;
                    } else {

                    }
                  }
                },
                error => {
                  
                  savingR=false;
                  this.saving=false&&(!savingF&&!savingR);
                  //this.showError("Errore durante la procedura di conferma");
                  //return false;
                }
              );
            }
            //UPDATE DATA
            this.incassiDettaglioService.getAssegni(this.incassoCorrente.tokenIncasso)
              .subscribe(
                resAssegni => {
                  
                  savingR=false;
                  this.saving=false&&(!savingF&&!savingR);
                  this.incassoCorrente.assegni = resAssegni;
                  //this.incassoCorrente.totaleAssegni += this.assegnoCorrente.importo;
                  //this.config.incassoRef.totaleAssegni+=this.assegnoCorrente.importo;
                  this.incassiDettaglioService.updateAssegni(this.assegnoCorrente);
                  this.showInfo("Salvataggio avvenuto con successo");
                  this.dialogRef.close(this.incassoCorrente);
                }, error => {
                });
          } else {
            this.showError(resA.message);
            savingR=false;
            this.saving=false&&(!savingF&&!savingR);
            this.dialogRef.close();
          }


        });
    }
    this.assegnoCorrente = null;
  }

  nuovoAssegno() {
    this.assegnoCorrente = new IncassoAssegniListItemModel();
    this.hasAssegno=true;
  }

  //apri dettaglio assegno, imposto assegno corrente
  modificaAssegno(a: IncassoAssegniListItemModel) {
    this.assegnoCorrente = a;

    console.log("data assegno:"+a.dataAssegno);
    a.dataAssegno=new Date(a.dataAssegno);
    this.getImageFromService("F");
    this.getImageFromService("R");
    //format data:
    // if (this.assegnoCorrente.dataAssegno.length > 10) {
    //   this.assegnoCorrente.dataAssegno = this.assegnoCorrente.dataAssegno.substring(0, 10);
    // }
    //this.assegnoCorrente.dataAssegno = this.formatDate(this.assegnoCorrente.dataAssegno);
  }


  eliminaAssegno(a: IncassoAssegniListItemModel, i: number) {
    this.incassiDettaglioService.deleteDettaglio(a.token)
      .subscribe(res => {
        //Aggiorna gli assegni dell'incasso corrente
        this.incassiDettaglioService.getAssegni(this.incassoCorrente.tokenIncasso)
          .subscribe(
            resA => {
              this.incassoCorrente.assegni = resA;
              this.getTotal();
              this.config.reload = true;
              this.config.incassoResult = this.incassoCorrente;
              this.hasAssegno=false;
            }, error => {
            });
        this.assegnoCorrente = null;
      });
  }


  getTotal(): number {
    this.incassoCorrente.totaleAssegni = 0;
    this.incassoCorrente.assegni.forEach(i => {
      if (!isNaN(i.importo)) {
        this.incassoCorrente.totaleAssegni += +i.importo;
      }
    });
    return this.incassoCorrente.totaleAssegni;
  }

  canSave() {
    // i dati sono modificabili solo se l'incasso è nuovo o in lavorazione
    //NB: la verifica dello stato viene fatta sul riferimento all'incasso originale
    return this.config.incassoRef.statoIncasso.id < 3;
  }

  // in caso di salvataggio viene restituito il nuovo oggetto dell'incasso
  salva() {
    if(this.incassoCorrente.assegni!=null&&this.incassoCorrente.assegni.length>0) {
      this.incassoCorrente.statoIncasso.id=2;
    }
    this.dialogRef.close(this.incassoCorrente);
  }

  // in caso di annullamento dell'operazione (o chiusura senza modifica), restituisco null
  annulla() {
    this.dialogRef.close(this.config.incassoRef);
  }

  focusDate() {
    initDatePicker();
  }

  /* VISUALIZZA IMMAGINE CARICATA */
  
  createImageFromBlob(image: Blob, fronteretro: string) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      if (fronteretro === "F") {
        this.imageToShowF = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
      } else {
        this.imageToShowR = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
      }
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }
  getImageFromService(fronteretro: string) {
    this.isImageLoading = true;
    this.incassiDettaglioService.getFileImage(this.assegnoCorrente.token, fronteretro).subscribe(data => {
      this.createImageFromBlob(data, fronteretro);
      this.isImageLoading = false;
    }, error => {
      this.isImageLoading = false;
    });
  }

  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  /* BANCHE e VERSAMENTI */
  onSearchChange(searchValue: string) {

    if (this.assegnoCorrente.abi && this.assegnoCorrente.cab) {
      this.isBancaLoading=true;
      this.incassiDettaglioService.getBancaByAbiCab(parseInt(this.assegnoCorrente.abi,10), parseInt(this.assegnoCorrente.cab,10))
        .subscribe(
          data => {
            if (data) {
              this.assegnoCorrente.nomeBanca = data.denominazione;
            } else {
              this.assegnoCorrente.nomeBanca = "";
              
            }
            this.isBancaLoading=false;
          },
          err => {
            this.assegnoCorrente.nomeBanca = "";
            this.assegnoCorrente.abi = "";
            this.assegnoCorrente.cab = "";
            this.showError("Errore nella ricerca delle banche");
            this.isBancaLoading=false;

          }

        );
    } else {
      this.assegnoCorrente.nomeBanca = "";
    }

  }
}





// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/distinta-assegni.component.ts